<ng-template elderToolbarColumn="right.actions">
  @if (!(exactStorageScope$ | async)) {
    <app-facility-menu></app-facility-menu>
  }
</ng-template>

<!-- Template for the Toolbar Header -->
<ng-template #headerKiosk let-storageScope>
  <mat-toolbar elderTheme color="primary">
    <div class="layout-row place-start-center gap-sm flex">
      <ng-container
        [ngTemplateOutlet]="title"
        [ngTemplateOutletContext]="{ $implicit: storageScope }"
      ></ng-container>

      <span class="flex"></span>

      @if (!(exactStorageScope$ | async)) {
        <app-facility-menu></app-facility-menu>
      }
    </div>
  </mat-toolbar>
</ng-template>

<ng-template #headerRegular let-storageScope>
  <ng-template elderToolbarColumn="left">
    <ng-container
      [ngTemplateOutlet]="title"
      [ngTemplateOutletContext]="{ $implicit: storageScope }"
    ></ng-container>
  </ng-template>
</ng-template>

<ng-template #title let-storageScope>
  <elder-header [header]="'storage.management' | translate" [subheader]="storageScope?.serialize()">
  </elder-header>
</ng-template>

@if (terminalCtx$ | async; as terminalCtx) {
  <elder-single-pane-wrapper>
    @if (terminalCtx.kioskMode) {
      <ng-container
        *elderShellSlot="'header'"
        [ngTemplateOutlet]="headerKiosk"
        [ngTemplateOutletContext]="{ $implicit: terminalCtx.storageScope }"
      ></ng-container>
      <!-- disable static navigation -->
      <ng-template elderShellSlot="static-nav"></ng-template>
    }
    @if (!terminalCtx.kioskMode) {
      <ng-container
        [ngTemplateOutlet]="headerRegular"
        [ngTemplateOutletContext]="{ $implicit: terminalCtx.storageScope }"
      ></ng-container>
    }
    <elder-table class="flex" [data]="data" (itemClick)="openDetail($event)" matSort>
      <div *elderTableToolbar class="layout-row place-start-center gap-md flex-none p-sm">
        <!-- Search Box -->
        <elder-search-box
          class="flex"
          dense
          placeholder="{{ 'storageGroups.storageGroup' | translate }}"
          [elderSearchContext]="data?.filter"
          queryKey="query"
        >
        </elder-search-box>
        <mat-form-field class="flex-30" subscriptSizing="dynamic" elderDense>
          <mat-label>{{ 'packages.number' | translate }}</mat-label>
          @if (packageNumberPrefixEnabled) {
            <span matPrefix>{{ packageNumberPrefix$ | async }}</span>
          }
          <input matInput name="packageNumber" [(ngModel)]="packageNumberInput" />
          <button
            mat-icon-button
            matSuffix
            [disabled]="!packageNumberInput"
            (click)="packageNumberInput = null"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
        <mat-slide-toggle [(ngModel)]="packageNumberPrefixEnabled"> Prefix </mat-slide-toggle>
        <button
          mat-flat-button
          [disabled]="!packageNumberInput"
          (click)="findByPackageNumber(packageNumberInput)"
        >
          {{ 'actions.search' | translate }}
          <mat-icon>search</mat-icon>
        </button>
      </div>
      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 10%; min-width: 150px">
          {{ 'ID' | translate }}
        </th>
        <td mat-cell *matCellDef="let group">{{ group?.id }}</td>
      </ng-container>
      <!-- base locations -->
      <ng-container matColumnDef="locations">
        <th *matHeaderCellDef mat-header-cell mat-sort-header="locations">
          {{ 'packageGroups.baseLocation' | translate }}
        </th>
        <td *matCellDef="let group" mat-cell>
          <mat-chip-listbox>
            @for (loc of group?.packageGroups; track loc) {
              <mat-chip-option
                [selected]="loc?.baseLocation.indexOf(terminalCtx.storageScope.serialize()) !== -1"
                color="accent"
              >
                {{ loc?.baseLocation }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </td>
      </ng-container>
      <!-- createdAt -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.createdAt' | translate }}
        </th>
        <td mat-cell *matCellDef="let group">
          {{ group?.createdAt | date: 'short' }}
        </td>
      </ng-container>
      <!-- modifiedAt -->
      <ng-container matColumnDef="modifiedAt">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.modifiedAt' | translate }}
        </th>
        <td mat-cell *matCellDef="let group">
          {{ group?.modifiedAt | date: 'short' }}
        </td>
      </ng-container>
    </elder-table>
  </elder-single-pane-wrapper>
}

<ng-template #noContext>
  <div class="layout-row place-center-center flex">
    <span>Kein Kontext</span>
  </div>
</ng-template>
